import clsx from 'clsx'

interface ButtonProps {
  className?: string
  onClick: () => void
  children: preact.ComponentChildren
}

export function Button({ className, onClick, children }: ButtonProps) {
  const handleClick = (e: MouseEvent) => {
    e.preventDefault()
    onClick && onClick()
  }
  return (
    <button
      onClick={handleClick}
      className={clsx(
        'flex items-center justify-center w-full text-base font-normal text-center text-black transition-colors border rounded select-none bg-yellow border-yellow h-14 focus:outline-none focus:ring focus:ring-white/50 hover:bg-black-80 hover:text-yellow',
        className,
      )}>
      {children}
    </button>
  )
}
